const steps = [
    {id: 1, title: 'About Multi-Currency Pricing (MCP)', name: 'about'},
    {id: 2, title: 'Methods of Processing MCP Transactions', name: 'mcp_trans'},
    {id: 3, title: 'MCP Get Rate', name: 'get_rate'},
    {id: 4, title: 'MCP Purchase', name: 'purchase'},
    {id: 5, title: 'MCP Purchase with 3-D Secure', name: 'purch_3ds'},
    {id: 6, title: 'MCP Purchase with Vault', name: 'purchase_v'},
    {id: 7, title: 'MCP Purchase with 3-D Secure and Vault', name: 'purch_3ds_v'},
    {id: 8, title: 'MCP Pre-Authorization', name: 'preauth'},
    {id: 9, title: 'MCP Pre-Authorization with 3-D Secure', name: 'preauth_3ds'},
    {id: 10, title: 'MCP Pre-Authorization with Vault', name: 'preauth_v'},
    {id: 11, title: 'MCP Pre-Authorization with 3-D Secure and Vault', name: 'preauth_3ds_v'},
    {id: 12, title: 'MCP Pre-Authorization Completion', name: 'preauth_comp'},
    {id: 13, title: 'MCP Purchase Correction', name: 'purch_corr'},
    {id: 14, title: 'MCP Refund', name: 'refund'},
    {id: 15, title: 'MCP Independent Refund', name: 'ind_refund'},
    {id: 16, title: 'MCP Independent Refund with Vault', name: 'indref_v'},
    {id: 17, title: 'MCP Currency Codes', name: 'curr_codes'},
    {id: 18, title: 'MCP Error Codes', name: 'err_codes'},
    {id: 19, title: 'MCP Testing Cards', name: 'tst_cards'},

]

export default steps